module.exports = __webpack_public_path__ + "img/product-sm-2.06f3bd7b.png";